/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Public API
 * API that powers FreightSimple\'s SPA
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Currency } from './Currency';
import {
    CurrencyFromJSON,
    CurrencyFromJSONTyped,
    CurrencyToJSON,
    CurrencyToJSONTyped,
} from './Currency';
import type { PaymentMethod } from './PaymentMethod';
import {
    PaymentMethodFromJSON,
    PaymentMethodFromJSONTyped,
    PaymentMethodToJSON,
    PaymentMethodToJSONTyped,
} from './PaymentMethod';
import type { InvoiceStanding } from './InvoiceStanding';
import {
    InvoiceStandingFromJSON,
    InvoiceStandingFromJSONTyped,
    InvoiceStandingToJSON,
    InvoiceStandingToJSONTyped,
} from './InvoiceStanding';
import type { InvoiceState } from './InvoiceState';
import {
    InvoiceStateFromJSON,
    InvoiceStateFromJSONTyped,
    InvoiceStateToJSON,
    InvoiceStateToJSONTyped,
} from './InvoiceState';
import type { InvoiceType } from './InvoiceType';
import {
    InvoiceTypeFromJSON,
    InvoiceTypeFromJSONTyped,
    InvoiceTypeToJSON,
    InvoiceTypeToJSONTyped,
} from './InvoiceType';

/**
 * 
 * @export
 * @interface Invoice
 */
export interface Invoice {
    /**
     * 
     * @type {Currency}
     * @memberof Invoice
     */
    currency: Currency;
    /**
     * 
     * @type {number}
     * @memberof Invoice
     */
    amount: number;
    /**
     * 
     * @type {string}
     * @memberof Invoice
     */
    invoiceDate: string;
    /**
     * 
     * @type {string}
     * @memberof Invoice
     */
    brand?: string;
    /**
     * 
     * @type {string}
     * @memberof Invoice
     */
    lastFourDigits?: string;
    /**
     * 
     * @type {string}
     * @memberof Invoice
     */
    invoicePdfKey: string;
    /**
     * 
     * @type {string}
     * @memberof Invoice
     */
    dueDate: string;
    /**
     * 
     * @type {InvoiceState}
     * @memberof Invoice
     */
    invoiceState: InvoiceState;
    /**
     * 
     * @type {InvoiceType}
     * @memberof Invoice
     */
    invoiceType: InvoiceType;
    /**
     * 
     * @type {PaymentMethod}
     * @memberof Invoice
     */
    paymentMethod?: PaymentMethod;
    /**
     * 
     * @type {string}
     * @memberof Invoice
     */
    shipmentId: string;
    /**
     * 
     * @type {string}
     * @memberof Invoice
     */
    invoiceIdentifier: string;
    /**
     * 
     * @type {boolean}
     * @memberof Invoice
     */
    lastPaymentAttemptFailed: boolean;
    /**
     * 
     * @type {string}
     * @memberof Invoice
     */
    invoiceId: string;
    /**
     * 
     * @type {string}
     * @memberof Invoice
     */
    bookedBy: string;
    /**
     * 
     * @type {string}
     * @memberof Invoice
     */
    branchId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Invoice
     */
    disputed: boolean;
    /**
     * 
     * @type {InvoiceStanding}
     * @memberof Invoice
     */
    standing: InvoiceStanding;
    /**
     * Whether this invoice is currently holding up booking. Stricter than a standing of Overdue: the instant-pay grace period has to have run out too.
     * @type {boolean}
     * @memberof Invoice
     */
    blockingBooking: boolean;
}



/**
 * Check if a given object implements the Invoice interface.
 */
export function instanceOfInvoice(value: object): value is Invoice {
    if (!('currency' in value) || value['currency'] === undefined) return false;
    if (!('amount' in value) || value['amount'] === undefined) return false;
    if (!('invoiceDate' in value) || value['invoiceDate'] === undefined) return false;
    if (!('invoicePdfKey' in value) || value['invoicePdfKey'] === undefined) return false;
    if (!('dueDate' in value) || value['dueDate'] === undefined) return false;
    if (!('invoiceState' in value) || value['invoiceState'] === undefined) return false;
    if (!('invoiceType' in value) || value['invoiceType'] === undefined) return false;
    if (!('shipmentId' in value) || value['shipmentId'] === undefined) return false;
    if (!('invoiceIdentifier' in value) || value['invoiceIdentifier'] === undefined) return false;
    if (!('lastPaymentAttemptFailed' in value) || value['lastPaymentAttemptFailed'] === undefined) return false;
    if (!('invoiceId' in value) || value['invoiceId'] === undefined) return false;
    if (!('bookedBy' in value) || value['bookedBy'] === undefined) return false;
    if (!('disputed' in value) || value['disputed'] === undefined) return false;
    if (!('standing' in value) || value['standing'] === undefined) return false;
    if (!('blockingBooking' in value) || value['blockingBooking'] === undefined) return false;
    return true;
}

export function InvoiceFromJSON(json: any): Invoice {
    return InvoiceFromJSONTyped(json, false);
}

export function InvoiceFromJSONTyped(json: any, ignoreDiscriminator: boolean): Invoice {
    if (json == null) {
        return json;
    }
    return {
        
        'currency': CurrencyFromJSON(json['currency']),
        'amount': json['amount'],
        'invoiceDate': json['invoiceDate'],
        'brand': json['brand'] == null ? undefined : json['brand'],
        'lastFourDigits': json['lastFourDigits'] == null ? undefined : json['lastFourDigits'],
        'invoicePdfKey': json['invoicePdfKey'],
        'dueDate': json['dueDate'],
        'invoiceState': InvoiceStateFromJSON(json['invoiceState']),
        'invoiceType': InvoiceTypeFromJSON(json['invoiceType']),
        'paymentMethod': json['paymentMethod'] == null ? undefined : PaymentMethodFromJSON(json['paymentMethod']),
        'shipmentId': json['shipmentId'],
        'invoiceIdentifier': json['invoiceIdentifier'],
        'lastPaymentAttemptFailed': json['lastPaymentAttemptFailed'],
        'invoiceId': json['invoiceId'],
        'bookedBy': json['bookedBy'],
        'branchId': json['branchId'] == null ? undefined : json['branchId'],
        'disputed': json['disputed'],
        'standing': InvoiceStandingFromJSON(json['standing']),
        'blockingBooking': json['blockingBooking'],
    };
}

  export function InvoiceToJSON(json: any): Invoice {
      return InvoiceToJSONTyped(json, false);
  }

  export function InvoiceToJSONTyped(value?: Invoice | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'currency': CurrencyToJSON(value['currency']),
        'amount': value['amount'],
        'invoiceDate': value['invoiceDate'],
        'brand': value['brand'],
        'lastFourDigits': value['lastFourDigits'],
        'invoicePdfKey': value['invoicePdfKey'],
        'dueDate': value['dueDate'],
        'invoiceState': InvoiceStateToJSON(value['invoiceState']),
        'invoiceType': InvoiceTypeToJSON(value['invoiceType']),
        'paymentMethod': PaymentMethodToJSON(value['paymentMethod']),
        'shipmentId': value['shipmentId'],
        'invoiceIdentifier': value['invoiceIdentifier'],
        'lastPaymentAttemptFailed': value['lastPaymentAttemptFailed'],
        'invoiceId': value['invoiceId'],
        'bookedBy': value['bookedBy'],
        'branchId': value['branchId'],
        'disputed': value['disputed'],
        'standing': InvoiceStandingToJSON(value['standing']),
        'blockingBooking': value['blockingBooking'],
    };
}

